<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog
            v-model="dialog"
            :persistent="dialog"
            content-class="elevation-0 border-radius-3 pt-0 d-flex justify-center align-center h-90vh"
            color="#323A46"
            overlay-color="#7764CA"
            overlay-opacity="1"
        >
            <div class="onboarding-logo-wrapper">
                <v-img
                    :src="logo"
                    width="100"
                    class="mx-auto">
                </v-img>
            </div>
            <v-row class="progress-bar-wrapper ma-0">
                <v-col cols="12" class="position-relative">
                    <v-progress-linear
                    background-color="#514585"
                    color="#C4BBE7"
                    v-model="completedQuestPercentage"
                    height="18"
                    class="pointer-events-none border-progress-bar"
                    rounded
                    >
                    <strong>{{ this.countQuestions }} / {{ this.totalPreguntas }}</strong>
                </v-progress-linear>
                    <v-img
                    :src="require('@/assets/img/icons/check-stroke.png')"
                    height="48"
                    width="48"
                    class="check-icon"
                    ></v-img>
                </v-col>
            </v-row>

            <v-container class="diagnostic-container-wrapper">
                <v-row class="row d-flex justify-center pa-0 ma-0 card-height">
                    <v-col cols="12" md="8" color="#fff" class="pa-0">
                        <v-card class="custom-card border-radius-2 pa-7 h-100">
                            <DiagnosticText
                                :data="diagnosticData[text_index].diagnostic"
                                @toogleQuestionsMobile="openQuestionDrawer" />

                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" class="border-radius-1 pa-0 hidden-md-and-down">
                        <v-card
                            class="custom-card h-100 border-radius-2 pa-7 d-flex flex-column position-relative"
                            color="#e9f5f4"
                            elevation="12"
                        >
                            <Question
                                :data="diagnosticData[text_index].diagnostic.questions[question_index]"
                                :question_number="question_index + 1"
                                :count_question="diagnosticData[text_index].diagnostic.questions.length"
                                @newSelection="newSelection"
                                :cleanSelection="cleanCounter"
                            />
                            <v-card-actions class="d-flex justify-center pa-0 mt-5">
                                <v-btn
                                    data-cy="diagnosticModal-nextQuestion-button"
                                    class="bg-gradient-primary px-15 border-radius-1 text-lowercase font-weight-bolder"
                                    large
                                    dark
                                    @click="nextQuestion"
                                    v-if="next_question"
                                    >
                                    <span class="first-letter-uppercase">{{ $t('initialTour.next_question') }}</span>
                                </v-btn>
                                <v-btn
                                    data-cy="diagnosticModal-nextText-button"
                                    class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                                    large
                                    dark
                                    @click="nextText"
                                    v-if="next_text"
                                    >{{ $t('initialTour.next_text') }}</v-btn
                                >
                                <v-btn
                                    data-cy="diagnosticModal-finish-button"
                                    class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                                    large
                                    dark
                                    :loading="btnLoaded"
                                    @click="nextPass"
                                    v-if="next_pass"
                                    >{{ $t('initialTour.finish') }}</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-navigation-drawer
                v-model="questionsDrawer"
                app
                right
                fixed
                temporary
                touchless
                overlay-color="pink"
                width="80%"
                class="hidden-md-and-up"
                >
                <v-container fluid class="d-flex align-items-center h-100">
                    <div>
                        <Question
                            :data="diagnosticData[text_index].diagnostic.questions[question_index]"
                            :question_number="question_index + 1"
                            :count_question="diagnosticData[text_index].diagnostic.questions.length"
                            @newSelection="newSelection"
                            :cleanSelection="cleanCounter"
                        />
                        <v-card-actions class="d-flex justify-center pa-0 mt-5">
                            <v-btn
                                data-cy="diagnosticModal-nextQuestion-button"
                                class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                                large
                                dark
                                @click="nextQuestion"
                                v-if="next_question"
                                >{{ $t('initialTour.next_question') }}</v-btn
                            >
                            <v-btn
                                data-cy="diagnosticModal-nextText-button"
                                class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                                large
                                dark
                                @click="nextText"
                                v-if="next_text"
                                >{{ $t('initialTour.next_text') }}</v-btn
                            >
                            <v-btn
                                data-cy="diagnosticModal-finish-button"
                                class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                                large
                                dark
                                :loading="btnLoaded"
                                @click="nextPass"
                                v-if="next_pass"
                                >{{ $t('initialTour.finish') }}</v-btn
                            >
                        </v-card-actions>
                    </div>
                </v-container>
            </v-navigation-drawer>

        </v-dialog>
    </v-row>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import DiagnosticService from '@/services/diagnostic'

import DiagnosticText from './DiagnosticCore/DiagnosticText.vue'
import Question from './DiagnosticCore/Question.vue'

import AnalyticEventsMixin from "../../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    mixins: [AnalyticEventsMixin],
    components: {
        DiagnosticText,
        Question,
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
            answer_body: (state) => state.dashboard.answer_body,
            showMobile: (state) => state.isMobile,
        }),
        next_question() {
            const nextQuestion = this.diagnosticData[this.text_index].diagnostic.questions.length - 1 > this.question_index
            this.countQuestions += 1
            return nextQuestion
        },
        next_text() {
            return (
                this.diagnosticData[this.text_index].diagnostic.questions.length - 1 === this.question_index &&
                this.diagnosticData.length - 1 > this.text_index
            )
        },
        next_pass() {
            return (
                this.diagnosticData.length - 1 === this.text_index &&
                this.diagnosticData[this.text_index].diagnostic.questions.length - 1 === this.question_index
            )
        },
        completedQuestPercentage() {
            const totalPreguntas = this.diagnosticData.reduce((total, elemento) => total + elemento.diagnostic.questions.length, 0);
            this.totalPreguntas = totalPreguntas;

            const totalPercent = Math.round((this.countQuestions / totalPreguntas) * 100);
            return totalPercent
        }
    },
    mounted() {
        this.setBookUserIdForDiagnostic(this.user.id)
    },
    data() {
        return {
            text_index: 0,
            question_index: 0,
            // eslint-disable-next-line global-require
            bee_3: require('@/assets/img/bees/bee003.svg'),
            btnLoaded: false,
            cleanCounter: 0,
            selectedId: null,
            questionsDrawer: null,
            totalPreguntas: 0,
            countQuestions: 0,
            logo: require('@/assets/img/brand/logo.svg'),
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'mountDiagnostic',
            'setBookUserIdForDiagnostic',
            'insertDiagnosticoPreguntaRespuesta',
            'showFinishOnBoardingModal',
        ]),
        newSelection(selectionId) {
            this.selectedId = selectionId
        },
        openQuestionDrawer() {
            this.questionsDrawer = true
        },
        closeQuestionDrawer() {
            this.questionsDrawer = false
        },
        async nextPass() {
            this.btnLoaded = true
            if (this.evaluateValue()){
                await DiagnosticService.answerDiagnostico(this.answer_body).catch((error) =>
                    console.error(error)
                )
                this.mountDiagnostic()
                this.showFinishOnBoardingModal()
                this.createAnalyticEvent(AnalyticEventTypes.OnboardingFinished)
                this.$ga.event('pageLoaded', 'onboardingFinished')
            }
            this.btnLoaded = false

        },
        nextQuestion() {
            if (this.evaluateValue()) {
                this.question_index += 1
            }
        },
        nextText() {
            if (this.evaluateValue()) {
                this.text_index += 1
                this.question_index = 0
            }
            window.scrollTo(0, 0)
            this.closeQuestionDrawer()
        },
        evaluateValue() {
            const preguntas = this.diagnosticData[this.text_index].diagnostic
            let radioValue = null
            if (this.selectedId !== null) {
                radioValue = this.selectedId
            } else {
                this.$modal.error(this.$t('initialTour.select_option'))
                return null
            }
            if (radioValue) {
                this.insertDiagnosticoPreguntaRespuesta({
                    preguntaId: preguntas.questions[this.question_index].id,
                    respuestaId: radioValue,
                })
                this.cleanCounter += 1
                this.newSelection(null)
            } else {
                this.$modal.error(this.$t('initialTour.select_option'))
                return null
            }
            return radioValue
        },
    },
}
</script>
<style lang="scss">
.card-height {
    height: 70vh;
}
.min-h-card{
    min-height: 15vh;
}

.border-main {
    box-shadow: inset 0 0 0 1px #4bada1;
}

.bee-corner {
    top: -6vh;
    right: -6vh;
}

.v-dialog {
    .diagnostic-container-wrapper {
        max-width: 95vw;
        margin-top: 50px;
        overflow-y: auto;
        overflow-x: hidden;
        @media screen and (max-width: 600px) {
            margin-top: 120px;
        }
    }
}
</style>
